export default __webpack_public_path__ + "static/seals-frontpage-139198845d444579b3ba271b7b59f02c.jpg";